export default class Modal {
   constructor() {
      this.modals = $('[data-fancybox-gallery]')

      this.init()
   }

   init() {
      this.modals.each(function() {
         const items = $(this).find('[data-fancybox-gallery-item]')

         if (items.length > 0) {
            const galleryImg = []
            let postImg
            let imgStart

            items.each(function(i) {
               postImg = $(this).attr('href')
               galleryImg[i] = {
                  src: postImg,
                  opts: {},
               };
               $(this).on('click', function(e) {
                  e.preventDefault()
                  $.fancybox.open(galleryImg, {
                     loop: true,
                     focus: false,
                     buttons: [
                        'close',
                     ],
                  })
                  imgStart = i
                  $.fancybox.getInstance().jumpTo(imgStart)
               })
            })
         }
      })
   }
}



//////////////////
// WEBPACK FOOTER
// ./js/components/modal.js
// module id = 12
// module chunks = 0